<template>
    <div class="admin">
        <b-container fluid>
            <b-row>
                <b-col cols="12" lg="4" xl="3" offset-xl="1">
                    <AdminSectionSelector/>
                </b-col>
                <b-col cols="12" lg="8" xl="7">
                    <keep-alive>
                        <router-view />
                    </keep-alive>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import AdminSectionSelector from './AdminSectionSelector'
export default {
    name: 'Admin',
    data () {
        return {
            columnDefs: null,
            rowData: null
        }
    },
    components: {
        AdminSectionSelector
    }
}
</script>
